import axios from "axios";
import { config } from "../../utils/axiosConfig";
import { base_url } from "../../utils/baseUrl";

const uploadImg = async (data) => {
  const response = await axios.post(`${base_url}upload/images`, data,  );
  return response.data;
};

const deleteImg = async (id) => {
  const response = await axios.delete(
    `${base_url}upload/images/${id}`,
    
  );
  return response.data;
};



const uploadDescImg = async (data) => {
  const response = await axios.post(`${base_url}upload/desc/images`, data,  );
  return response.data;
};

const deleteDescImg = async (id) => {
  const response = await axios.delete(
    `${base_url}upload/desc/images/${id}`,
     
  );
  return response.data;
};
 
 

const uploadService = {
  uploadImg,
  deleteImg,
  uploadDescImg,
  deleteDescImg,
};

export default uploadService;
